/**
 * --------------------------------------------
 * AdminLTE Treeview.js
 * License MIT
 * --------------------------------------------
 */

const Treeview = (($) => {
    /**
     * Constants
     * ====================================================
     */

    const NAME = 'Treeview'
    const DATA_KEY = 'lte.treeview'
    const EVENT_KEY = `.${DATA_KEY}`
    const JQUERY_NO_CONFLICT = $.fn[NAME]

    const Event = {
        SELECTED: `selected${EVENT_KEY}`,
        EXPANDED: `expanded${EVENT_KEY}`,
        COLLAPSED: `collapsed${EVENT_KEY}`,
        LOAD_DATA_API: `load${EVENT_KEY}`
    }

    const Selector = {
        LI: '.nav-item',
        LINK: '.nav-link',
        TREEVIEW_MENU: '.nav-treeview',
        OPEN: '.menu-open',
        DATA_WIDGET: '[data-widget="treeview"]'
    }

    const ClassName = {
        LI: 'nav-item',
        LINK: 'nav-link',
        TREEVIEW_MENU: 'nav-treeview',
        OPEN: 'menu-open'
    }

    const Default = {
        trigger: `${Selector.DATA_WIDGET} ${Selector.LINK}`,
        animationSpeed: 300,
        accordion: true
    }

    /**
     * Class Definition
     * ====================================================
     */
    class Treeview {
        constructor(element, config) {
            this._config = config
            this._element = element
        }

        // Public

        init() {
            this._setupListeners()
        }

        expand(event) {
            const $relativeTarget = $(event.currentTarget);
            const treeviewmenu = $relativeTarget.find("> " + Selector.TREEVIEW_MENU);
            const offset = $relativeTarget.offset();
            const offsetLeft = $($relativeTarget).outerWidth(true);
            const offsetTop = $($relativeTarget).offset().top - $(window).scrollTop();
            const rt = $(window).width() - offset.left;
            if ($("html").attr("dir") == "rtl") {
                treeviewmenu.css({ position: "fixed", right: rt + "px", top: offsetTop + "px", display: "block" });
            } else {
                treeviewmenu.css({ position: "fixed", left: offset.left + offsetLeft + "px", top: offsetTop + "px", display: "block"});
            }
            $relativeTarget.addClass(ClassName.OPEN);
            
        }

        collapse(event) {
            const $relativeTarget = $(event.currentTarget);
            const treeviewmenu = $relativeTarget.find("> " + Selector.TREEVIEW_MENU);
            treeviewmenu.attr("style", "");
            $relativeTarget.removeClass(ClassName.OPEN);
        }

        toggle(event) {
            const $relativeTarget = $(event.currentTarget)
            const treeviewMenu = $relativeTarget.next()
            if (!treeviewMenu.is(Selector.TREEVIEW_MENU)) {
                return
            }

            event.preventDefault()

            const parentLi = $relativeTarget.parents(Selector.LI).first()
            const isOpen = parentLi.hasClass(ClassName.OPEN)
            if (isOpen) {
                this.collapse($(treeviewMenu), parentLi)
            } else {
                this.expand($(treeviewMenu), parentLi)
            }
        }

        // Private

        _setupListeners() {
            let prevElement = null;
            let el = $(this._config.trigger).parent();
            el.mouseenter((event) => {
                if (prevElement !== null && prevElement[0] == $(event.currentTarget).parents("li.has-treeview")[0]) { 
                    clearTimeout($(this).data('timeoutId'));
                }
                
                prevElement = $(event.currentTarget);
                this.expand(event)
            }).mouseleave((event) => {
                if ($(event.currentTarget).parents("li.has-treeview")[0]) {
                    $(event.currentTarget).find(".nav-treeview").attr("style", "display: none");
                    $(event.currentTarget).removeClass(ClassName.OPEN);
                }
                let someElement = $(this),
                    timeoutId = setTimeout(() => {
                        this.collapse(event)
                    }, 100);
                someElement.data('timeoutId', timeoutId);
            });
        }

        // Static 

        static _jQueryInterface(config) {
            return this.each(function () {
                let data = $(this).data(DATA_KEY)
                const _config = $.extend({}, Default, $(this).data())

                if (!data) {
                    data = new Treeview($(this), _config)
                    $(this).data(DATA_KEY, data)
                }

                if (config === 'init') {
                    data[config]()
                }
            })
        }
    }

    /**
     * Data API
     * ====================================================
     */

    $(window).on(Event.LOAD_DATA_API, () => {
        $(Selector.DATA_WIDGET).each(function () {
            Treeview._jQueryInterface.call($(this), 'init')
        })
    })

    /**
     * jQuery API
     * ====================================================
     */

    $.fn[NAME] = Treeview._jQueryInterface
    $.fn[NAME].Constructor = Treeview
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT
        return Treeview._jQueryInterface
    }

    return Treeview
})(jQuery)

export default Treeview
